export default "__VITE_ASSET__DIxoysE7__"